export function mm2tocm2(mm2: number): number {
  return mm2 * 0.01
}

export function mmtocm(mm: number): number {
  return mm * 0.1
}

export function mm2tom2(mm2: number): number {
  return mm2 / 1000000
}
